export const sliceTextUpToColon = (text) => {
  const index = text.indexOf(":");
  if (index !== -1) {
    return text.slice(0, index + 1);
  }
  return "";
};
